module.exports = __webpack_public_path__ + "img/alf-days.71f8cbd6.jpg";